import { render, staticRenderFns } from "./SasvTnc.vue?vue&type=template&id=31700cde"
import script from "./SasvTnc.vue?vue&type=script&lang=js"
export * from "./SasvTnc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports